import React, { useRef } from "react"
import UniversalLink from "@/components/common/Links/UniversalLink"
import Text from "@/components/common/Text"
import { BUTTON_TYPE } from "@/constants"
import { useDispatch } from "react-redux"
import { setIsMenuOpen } from "@/state/menuSlice"
import NewsletterModalAction from "@/components/common/StructuredText/components/Blocks/BulletPointsWithActions/ActionsVariants/NewsletterModalAction"

const Item = ({
	external = false,
	isInfoItem = false,
	openNewsletter = false,
	square = true,
	newCard = "",
	url,
	children,
	color = "",
	...props
}) => {
	const dispatch = useDispatch()
	const newsletterActionRef = useRef()

	const Tag = openNewsletter ? "div" : UniversalLink

	const handleClick = () => {
		if (!openNewsletter) {
			return dispatch(setIsMenuOpen(false))
		}

		if (newsletterActionRef.current && newsletterActionRef.current.handleModalOpen) {
			newsletterActionRef.current.handleModalOpen()
		}
	}

	return (
		<>
			{openNewsletter && <NewsletterModalAction showButton={false} ref={newsletterActionRef} />}
			<Tag
				onClick={handleClick}
				external={openNewsletter ? undefined : external}
				newCard={openNewsletter ? undefined : newCard}
				href={url}
				type={external ? BUTTON_TYPE.UNSTYLED : undefined}
				style={{ cursor: "pointer" }}
				{...props}
			>
				<Text
					className={`${!isInfoItem ? `item  typo-strawford typo-strawford-43` : " typo-borna typo-borna-42 "} ${square ? "square" : ""} header`}
					color={color || (isInfoItem ? "chineseViolet" : "black")}
				>
					{children}
				</Text>
			</Tag>
		</>
	)
}

export default Item
